import { render, staticRenderFns } from "./UnProvisionedDevicesTable.vue?vue&type=template&id=671a4e2e&scoped=true&"
import script from "./UnProvisionedDevicesTable.vue?vue&type=script&lang=js&"
export * from "./UnProvisionedDevicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a4e2e",
  null
  
)

export default component.exports